import { Box, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Grid } from '@material-ui/core';
import { Layout } from '@roc/feature-app-core';
import { Button, createTextField } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useLenderBankInformationStore } from '../../../hooks/useLenderBankInformationStore';
import { CadenceTemplatesSection } from './cadenceTemplatesSection';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  dialogStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonStyle: {
    marginRight: '10px',
    height: '40px'
  },
  buttonContainer: {
    padding: '3px'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2)
  }
}));

export const CadenceTemplates = observer(() => {
  const [openModal, setOpenModal] = useState(false);
  const { cadenceStore } = useStore();
  const { cadenceForm } = cadenceStore;
  const store = cadenceForm;
  const classes = useStyles();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleConfirmation = () => {
    const cadenceName = store.form.fields.cadenceName.value;
    cadenceStore.createCadence(cadenceName);
    setOpenModal(false);
  };

  return (
    <Layout title="Cadence Templates">
      <Box className={classes.headerContainer}>
        <Button
          style={{ marginRight: '10px', height: '40px' }}
          size='small'
          variant="contained"
          type="submit"
          onClick={handleOpenModal}
          testId="submit"
          color='primary'
        >
          <span>CREATE CADENCE</span>
        </Button>
      </Box>

      <CadenceTemplatesSection />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            minWidth: '800px',
            maxWidth: '800px',
            minHeight: '270px',
            maxHeight: '270px',
          },
        }}
      >
        <DialogTitle>Create Cadence Template</DialogTitle>
        <DialogContent className={classes.dialogStyle}>
          <FormControl fullWidth>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={12}>
                {createTextField({
                  store,
                  label: 'Cadence Name',
                  fieldName: 'cadenceName',
                  testId: 'cadenceName',
                })}
              </Grid>
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <div className={classes.buttonContainer}>
            <Button
              className={classes.buttonStyle}
              size='small'
              variant="contained"
              type="submit"
              onClick={handleCloseModal}
              color='primary'
              testId="cancelButton"
            >
              Cancel
            </Button>
            <Button
              className={classes.buttonStyle}
              size='small'
              variant="contained"
              type="submit"
              onClick={handleConfirmation}
              color='primary'
              testId="requestingButton"
            >
              Create
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Layout>
  );
});
